export const verySmall = [1, 6, 7, 8];
export const small = [-2, 2, 9, 10, 11];
export const medium = [3, 12, 13, 14];
export const large = [4, 15, 16, 17];
export const veryLarge = [5];
export const platforms = [
  {
    label: 'Institutional App',
    value: 'institutional',
  },
  {
    label: 'Common App',
    value: 'common',
  },
  {
    label: 'Coalition App',
    value: 'coalition',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const schoolSizes = {
  small: 1,
  medium: 2001,
  large: 15001
}